export default __webpack_public_path__ + "/assets/vivi-book-verde-lg.jpg";